var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { margin } from 'styled-system';
var StyledFormWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", "px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  ", "\n  width: 100%\n"], ["\n  background-color: ", ";\n  padding: ", "px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  ", "\n  width: 100%\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.space[4];
}, margin);
export var StyledInputFormWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: ", "px;\n  > label {\n    font-size: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: ", "px;\n  > label {\n    font-size: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.space[4];
}, function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.caption;
});
export default StyledFormWrapper;
var templateObject_1, templateObject_2;
